import { PostgresIconUrl } from "@p0security/shared/integrations/constants";
import type { AwsIntegration } from "@p0security/shared/integrations/resources/aws/types";
import { PostgresComponents } from "@p0security/shared/integrations/resources/postgres/components";
import { Typography } from "antd";
import { useCallback } from "react";

import { useFirestoreDoc } from "../../../providers/FirestoreProvider.tsx";
import { Install, InstallProps } from "../Install/Install";
import { pgInstaller } from "./install/install";

const PgPreamble = (
  <>
    <Typography.Paragraph>
      Enable secure, granular access control for PostgreSQL databases on Google
      Cloud SQL and Amazon RDS with automated provisioning and audit logging.
    </Typography.Paragraph>
    <Typography.Text strong>Prerequisites:</Typography.Text>
    <ul className="preamble-list">
      <li>
        A fully managed PostgreSQL database on Google Cloud SQL or Amazon RDS
      </li>
    </ul>
  </>
);

export const Pg = (
  props: Pick<
    InstallProps<typeof PostgresComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const aws = useFirestoreDoc<AwsIntegration>("integrations/aws", {
    tenantAware: true,
  });
  const itemKind = useCallback(
    (use: string) =>
      use === "row-security-policy" ? "security policy" : "database",
    []
  );
  return (
    <Install<typeof PostgresComponents>
      components={PostgresComponents}
      installer={pgInstaller(aws)}
      integration="pg"
      itemKind={itemKind}
      logo={PostgresIconUrl}
      preamble={PgPreamble}
      title={"PostgreSQL"}
      {...props}
    />
  );
};
